import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import _ from 'lodash';
import Pagination from '@/components/pagination/Pagination';
import useScrollToTop from '@/hooks/useScrollToTop';
import Results from './Results';
import useFilterCount from '@/hooks/useFilterCount';
import useQuery from '@/pages/projects/useQuery';
import DistanceFilter from '@/pages/projects/DistanceFilter';
import FilterButton from '@/pages/people-partners/FilterButton';
import PaginationInformation from '@/components/pagination/PaginationInformation';
import SortBy from '@/pages/projects/SortBy';
import { attributeKeys } from '@/pages/projects/queryUtils';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import useDialogConfig from '@/dialogs-routable/_hooks/useDialogConfig';
import { DialogManager } from '@/dialogs_new/DialogManager';
import { useUser } from '@lore/auth';

Layout.propTypes = {
  router: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default function Layout(props) {
  const { router } = props;
  const { location } = router;

  const currentUser = useUser();

  const search = queryString.parse(location.search);
  if (!search.order) {
    search.order = 'featuredAt DESC NULLS LAST, createdAt DESC';
  }
  const filterCount = useFilterCount(search, _.filter(attributeKeys, key => [
    'networks',
    'interactionTypes',
    'locationCondition'
  ].indexOf(key) < 0));

  const node = useRef();
  const scrollToTop = useScrollToTop();

  const pageSize = 6;

  const result = useQuery({
    search,
    pageSize,
    showPast: true,
    distance: currentUser.data
  });

  const launch = useDialogLauncher();
  const config = useDialogConfig();

  function showFilters() {
    launch(DialogManager.FiltersProject.Config(config?.id, {
      showPast: true
    }));
  }

  return (
    <>
      <div ref={node} className="flex flex-col sm:flex-row flex-wrap gap-4 justify-between">
        <div className="flex flex-col sm:flex-row gap-4">
          <DistanceFilter />
        </div>
        <div className="flex flex-col sm:flex-row gap-4">
          <SortBy
            withBeginning={false}
            withExpiring={false}
            withDistance={true}
            withFeatured={true}
            defaultOrder="Featured"
          />
          <FilterButton
            count={filterCount}
            onClick={showFilters}
          />
        </div>
      </div>
      <Results result={result} />
      <div className="flex items-center justify-between">
        <PaginationInformation
          pageSize={pageSize}
          totalCount={result.meta?.totalCount}
        />
        <Pagination
          pageSize={pageSize}
          totalCount={result.meta?.totalCount}
          onNavigate={() => scrollToTop(node)}
        />
      </div>
    </>
  );
}
